import { addDays, startOfDay } from 'date-fns'
import type { TaskDocument } from '@/lib/db/rxdb/schemas/task'

export type DueGroupId = 'overdue' | 'today' | 'tomorrow' | 'upcoming' | 'noDate'

export type DueGroup = { id: DueGroupId; tasks: Array<TaskDocument> }

const ORDER: Array<DueGroupId> = ['overdue', 'today', 'tomorrow', 'upcoming', 'noDate']

/**
 * Bucket tasks by due date for triage (design 13a): Overdue → Today →
 * Tomorrow → Upcoming → No date. Order inside a bucket is preserved; empty
 * buckets are dropped.
 */
export function groupTasksByDue(tasks: ReadonlyArray<TaskDocument>, now: number = Date.now()): Array<DueGroup> {
  const today = startOfDay(now).getTime()
  const tomorrow = addDays(today, 1).getTime()
  const dayAfter = addDays(today, 2).getTime()

  const buckets = new Map<DueGroupId, Array<TaskDocument>>(ORDER.map((id) => [id, []]))
  for (const task of tasks) {
    const due = task.dueDate
    const id: DueGroupId =
      due == null
        ? 'noDate'
        : due < today
          ? 'overdue'
          : due < tomorrow
            ? 'today'
            : due < dayAfter
              ? 'tomorrow'
              : 'upcoming'
    buckets.get(id)?.push(task)
  }
  return ORDER.map((id) => ({ id, tasks: buckets.get(id) ?? [] })).filter((g) => g.tasks.length > 0)
}
